import React from 'react';
import logo from './logo.svg';
import Text from "./features/textInput/Text";
import './App.css';
import Layout from "./pages/layout/layout";

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
